import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
// import { ClerkProvider } from '@clerk/clerk-react'
// Import your publishable key
import TagManager from 'react-gtm-module';
const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key")
}

const tagManagerArgs = {
  gtmId: 'GTM-N92GD73H' // Replace with your GTM ID
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
     {/* <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/"> */}
    <BrowserRouter>
    <App />
    </BrowserRouter>
     {/* </ClerkProvider> */}
  </React.StrictMode>
);

reportWebVitals();
